<template>
  <a-modal class="confirm_modal" v-model:open="confirmVisible" @cancel="handleCancel" :footer="null">
    <img src="@/assets/images/confirm_icon.svg" class="confirm_icon" alt="" />
    <div class="confirm_text">{{ confirmText }}</div>
    <div class="btn_wrapper">
      <a-button class="cancel_btn" @click="handleCancel">{{ cancelBtnText }}</a-button>
      <a-button class="confirm_btn" type="primary" @click.prevent="handleComfirm">
        {{ confirmBtnText }}
      </a-button>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, defineExpose, defineEmits } from 'vue';

const emit = defineEmits(['confirm', 'cancel']);
const confirmVisible = ref(false);
const cancelBtnText = ref(false);
const confirmBtnText = ref(false);

const confirmText = ref(null);
const handelInit = (data) => {
  confirmVisible.value = true;
  confirmText.value = data.content;
  cancelBtnText.value = data.cancelBtnTextVal || 'Cancel';
  confirmBtnText.value = data.confirmBtnTextVal || 'Confirm';
};
const handleCancel = () => {
  confirmVisible.value = false;
  emit('cancel');
};
const handleComfirm = () => {
  confirmVisible.value = false;
  emit('confirm');
};

defineExpose({
  handelInit,
});
</script>

<style lang="less">
.confirm_modal {
  color: #05644f;
  font-size: 16px;
  .ant-modal-content {
    border-radius: 20px;
    padding: 32px;
  }
  .ant-modal-title {
    color: #05644f;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
  }
  .ant-modal-close-icon {
    color: #05644f;
  }
  .btn_wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 20px;
  }
  .confirm_btn,
  .cancel_btn {
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    line-height: normal;
    display: block;
    flex: 1;
    padding: 10px 20px;
    height: auto;
    margin-top: 20px;
    border: none;
    &.cancel_btn {
      background: rgba(5, 100, 79, 0.3);
      color: #fff;
    }
    &.confirm_btn {
      background: #05644f;
      color: #fff;
    }
  }
  .confirm_icon {
    width: 80px;
    height: 80px;
    margin: 50px auto;
    display: block;
  }
  .confirm_text {
    font-size: 16px;
    font-weight: normal;
    margin: 30px auto;
    color: #3d3d3d;
    text-align: center;
  }
}
</style>
